import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const icons = {
  dashboard: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
  tours: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>,
  new: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>,
  settings: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>,
  escalation: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  email: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  logout: <svg style={{ width: 14, height: 14 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  bug: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  sun: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>,
  moon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
  supplies: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
  reports: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  help: <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
};

const roleLabels = {
  staff: 'Field Staff',
  building_admin: 'Building Admin',
  regional_manager: 'Regional Manager',
  executive_staff: 'Executive Staff',
  super_admin: 'Super Admin',
  maintenance: 'Maintenance',
  environmental: 'Environmental',
};

const getInitialTheme = () => {
  try { return localStorage.getItem('pillar-theme') || 'light'; }
  catch { return 'light'; }
};

export default function Layout() {
  const { user, logout, API } = useAuth();
  const navigate = useNavigate();
  const [bugModal, setBugModal] = useState(false);
  const [bugText, setBugText] = useState('');
  const [bugMsg, setBugMsg] = useState('');
  const [bugSending, setBugSending] = useState(false);
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('pillar-theme', theme); } catch {}
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  const sendBug = async () => {
    if (!bugText.trim()) { setBugMsg('Please describe the issue.'); return; }
    setBugSending(true);
    setBugMsg('');
    try {
      await API.post('/admin/report-bug', {
        description: bugText,
        reporter: `${user?.firstName} ${user?.lastName}`,
        email: user?.email,
        role: user?.role,
        url: window.location.href,
      });
      setBugMsg('✅ Bug report sent!');
      setBugText('');
      setTimeout(() => { setBugModal(false); setBugMsg(''); }, 2000);
    } catch (e) {
      setBugMsg('❌ Failed to send. Please try again.');
    } finally {
      setBugSending(false);
    }
  };

  const canStartTour = ['staff', 'regional_manager', 'executive_staff', 'super_admin'].includes(user?.role);
  const isAdmin = user?.role === 'super_admin';

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <h1>Pillar Tour</h1>
          <span>Management System</span>
        </div>
        <div className="sidebar-user">
          <div className="sidebar-user-name">{user?.firstName} {user?.lastName}</div>
          <div className="sidebar-user-role">{roleLabels[user?.role]}</div>
          {user?.facilityName && <div className="sidebar-user-role" style={{ marginTop: 2 }}>{user.facilityName}</div>}
        </div>
        <nav className="sidebar-nav">
          <div className="nav-section-label">Overview</div>
          <NavLink to="/dashboard" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.dashboard}<span>Dashboard</span></NavLink>
          <div className="nav-section-label" style={{ marginTop: 8 }}>Tours</div>
          <NavLink to="/tours" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.tours}<span>All Tours</span></NavLink>
          {canStartTour && <NavLink to="/tours/new" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.new}<span>New Tour</span></NavLink>}
          {!['maintenance', 'environmental'].includes(user?.role) && (
            <>
              <div className="nav-section-label" style={{ marginTop: 8 }}>Inventory</div>
              <NavLink to="/supplies" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.supplies}<span>Supplies</span></NavLink>
            </>
          )}
          {['building_admin', 'regional_manager', 'executive_staff', 'super_admin'].includes(user?.role) && (
            <>
              <div className="nav-section-label" style={{ marginTop: 8 }}>Insights</div>
              <NavLink to="/reports" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.reports}<span>Reports</span></NavLink>
            </>
          )}
          <div className="nav-section-label" style={{ marginTop: 8 }}>Support</div>
          <NavLink to="/help" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.help}<span>How-To Guide</span></NavLink>
          {isAdmin && (
            <>
              <div className="nav-section-label" style={{ marginTop: 8 }}>Admin</div>
              <NavLink to="/settings" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.settings}<span>Settings</span></NavLink>
              <NavLink to="/escalation-chain" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.escalation}<span>Escalation Chain</span></NavLink>
              <NavLink to="/email-templates" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>{icons.email}<span>Email Templates</span></NavLink>
            </>
          )}
        </nav>
        <div className="sidebar-footer">
          <button
            className="sidebar-action-btn"
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? icons.sun : icons.moon}
            <span>{theme === 'dark' ? 'Light mode' : 'Dark mode'}</span>
          </button>
          <button className="sidebar-action-btn" onClick={() => { setBugModal(true); setBugMsg(''); setBugText(''); }}>
            {icons.bug}
            <span>Report a Bug</span>
          </button>
          <button className="logout-btn" onClick={() => { logout(); navigate('/login'); }}>{icons.logout}<span>Sign Out</span></button>
        </div>

        {bugModal && (
          <div className="modal-overlay" onClick={() => setBugModal(false)}>
            <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 440 }}>
              <div className="modal-header">
                <h3>🐛 Report a Bug</h3>
                <button className="modal-close" onClick={() => setBugModal(false)}>×</button>
              </div>
              <div className="modal-body">
                <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 12 }}>Describe what happened and what you expected to happen.</p>
                <textarea className="form-control" rows={5} placeholder="e.g. When I click Submit Tour, it shows an error message instead of saving..." value={bugText} onChange={e => setBugText(e.target.value)} style={{ resize: 'vertical' }} autoFocus />
                {bugMsg && <div style={{ fontSize: 13, marginTop: 8, fontWeight: 500, color: bugMsg.startsWith('✅') ? 'var(--green)' : bugMsg.startsWith('❌') ? 'var(--red)' : 'var(--text-secondary)' }}>{bugMsg}</div>}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setBugModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={sendBug} disabled={bugSending}>{bugSending ? 'Sending...' : 'Send Report'}</button>
              </div>
            </div>
          </div>
        )}
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
